"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _chartDataPropTypes = require("../../chartDataPropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Checkbox = /*#__PURE__*/function (_Component) {
  _inherits(Checkbox, _Component);

  var _super = _createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _super.call(this, props);
    _this.state = {
      isChecked: props.value
    };
    return _this;
  }

  _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isChecked: this.props.value
      });
    }
  }, {
    key: "toggleCheckboxChange",
    value: function toggleCheckboxChange() {
      var _this$props = this.props,
          handleCheckboxChange = _this$props.handleCheckboxChange,
          label = _this$props.label;
      this.setState(function (_ref) {
        var isChecked = _ref.isChecked;
        return {
          isChecked: !isChecked
        };
      });
      handleCheckboxChange(label);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          label = _this$props2.label,
          actualValue = _this$props2.actualValue,
          indeterminate = _this$props2.indeterminate;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          "float": "left"
        }
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "checkbox",
        value: label,
        checked: actualValue,
        onChange: this.toggleCheckboxChange.bind(this),
        ref: function ref(checkbox) {
          checkbox ? checkbox.indeterminate = indeterminate : null;
        }
      }), /*#__PURE__*/_react["default"].createElement("label", null, label));
    }
  }]);

  return Checkbox;
}(_react.Component);

Checkbox.propTypes = {
  label: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].bool.isRequired,
  actualValue: _propTypes["default"].bool.isRequired,
  indeterminate: _propTypes["default"].bool.isRequired,
  handleCheckboxChange: _propTypes["default"].func.isRequired
};

var CategoryCheckboxes = /*#__PURE__*/function (_React$Component) {
  _inherits(CategoryCheckboxes, _React$Component);

  var _super2 = _createSuper(CategoryCheckboxes);

  function CategoryCheckboxes(props) {
    var _this2;

    _classCallCheck(this, CategoryCheckboxes);

    _this2 = _super2.call(this, props);
    _this2.state = {
      selected: [],
      unselected: [],
      indeterminate: []
    };
    return _this2;
  }

  _createClass(CategoryCheckboxes, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.selectedCheckboxes = new Set();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleCurrentCheckboxSelection();
    }
  }, {
    key: "_updateFiltersSelected",
    value: function _updateFiltersSelected(checked, unchecked) {
      this.setState({
        selected: checked,
        unselected: unchecked
      });
    }
  }, {
    key: "toggleCheckbox",
    value: function toggleCheckbox(label) {
      var _this3 = this;

      var selected = this.state.selected; //First time is empty

      if (this.selectedCheckboxes.size === 0) {
        selected.forEach(function (item) {
          return _this3.selectedCheckboxes.add(item);
        });
      } //Checks if a specific checkbox label is in the set


      if (this.selectedCheckboxes.has(label)) {
        this.selectedCheckboxes["delete"](label);
      } else {
        this.selectedCheckboxes.add(label);
      } //For all the selectedCheckboxes set, we need to update the filters


      this.handleFiltersSelection();
    }
  }, {
    key: "handleFiltersSelection",
    value: function handleFiltersSelection() {
      var _this$props3 = this.props,
          onChangeCurrentValues = _this$props3.onChangeCurrentValues,
          allValues = _this$props3.allValues;
      var checkboxesSelected = [];

      var _iterator = _createForOfIteratorHelper(this.selectedCheckboxes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var checked = _step.value;
          !checkboxesSelected.includes(checked) ? checkboxesSelected.push(checked) : null;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._updateFiltersSelected(checkboxesSelected);

      var filteredValues = allValues.filter(function (item) {
        return checkboxesSelected.length > 0 ? checkboxesSelected.map(function (val) {
          return item.categories.indexOf(val);
        }).map(function (val) {
          return val > -1;
        }).reduce(function (acc, cum) {
          return acc || cum;
        }) : "";
      });
      onChangeCurrentValues(filteredValues);
    }
  }, {
    key: "_manageCheckedCategories",
    value: function _manageCheckedCategories(currentValues, categories) {
      var commonCategories = [];
      var existCurrentCategory = false;
      categories.forEach(function (category) {
        currentValues.forEach(function (value) {
          if (value.categories.includes(category.name)) {
            existCurrentCategory = true;
          }
        });

        if (existCurrentCategory) {
          commonCategories.push(category.name);
        }

        existCurrentCategory = false;
      });
      return commonCategories;
    }
  }, {
    key: "_manageUncheckedCategories",
    value: function _manageUncheckedCategories(allValues, currentValues) {
      var uncheckedCategories = [];
      allValues.forEach(function (value) {
        if (!currentValues.includes(value)) {
          //value is unchecked
          //uncheckCategories array does not contain value categories
          value.categories.forEach(function (item) {
            if (!uncheckedCategories.includes(item)) {
              uncheckedCategories.push(item);
            }
          });
        }
      });
      return uncheckedCategories;
    }
  }, {
    key: "handleCurrentCheckboxSelection",
    value: function handleCurrentCheckboxSelection() {
      var _this$props4 = this.props,
          currentValues = _this$props4.currentValues,
          allValues = _this$props4.allValues,
          categories = _this$props4.categories,
          currentTab = _this$props4.currentTab;

      var commonCategories = this._manageCheckedCategories(currentValues, categories);

      var uncheckedCategories = this._manageUncheckedCategories(allValues, currentValues);

      var checkedCategories = []; //Some of the values have more than one category, but only one is selected, in this case we need to check
      //that this category isn't in the unchecked ones

      commonCategories.forEach(function (category) {
        !uncheckedCategories.includes(category) && currentTab === "" ? checkedCategories.push(category) : "";
      });

      this._updateFiltersSelected(checkedCategories, uncheckedCategories);
    }
  }, {
    key: "_manageIndeterminates",
    value: function _manageIndeterminates(allValues, currentValues, categories, selected) {
      var commonCategories = this._manageCheckedCategories(currentValues, categories);

      var uncheckedCategories = this._manageUncheckedCategories(allValues, currentValues); //Some of the values have more than one category, but only one is selected, in this case we need to check
      //that this category isn't in the unchecked ones


      var realCommonCategories = commonCategories.filter(function (e) {
        return selected.includes(e);
      });
      var indeterminateCategories = [];
      realCommonCategories.forEach(function (category) {
        uncheckedCategories.includes(category) ? indeterminateCategories.push(category) : "";
      });
      return indeterminateCategories;
    }
  }, {
    key: "createCheckbox",
    value: function createCheckbox(label) {
      var selected = this.state.selected;
      var currentTab = this.props.currentTab;
      var _this$props5 = this.props,
          categories = _this$props5.categories,
          allValues = _this$props5.allValues,
          currentValues = _this$props5.currentValues;
      var value = currentTab === "All" ? true : currentTab === "None" ? false : selected ? selected.includes(label) : false;

      var indeterminates = this._manageIndeterminates(allValues, currentValues, categories, selected);

      var indeterminateValue = indeterminates.includes(label);
      return /*#__PURE__*/_react["default"].createElement(Checkbox, {
        key: label,
        label: label,
        value: value,
        actualValue: value,
        indeterminate: indeterminateValue,
        handleCheckboxChange: this.toggleCheckbox.bind(this)
      });
    }
  }, {
    key: "createCheckboxes",
    value: function createCheckboxes() {
      var categories = this.props.categories;
      var categories_names = categories.map(function (c) {
        return c.name;
      });
      return categories_names.map(this.createCheckbox.bind(this));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "columns small-9"
      }, this.createCheckboxes());
    }
  }]);

  return CategoryCheckboxes;
}(_react["default"].Component);

CategoryCheckboxes.propTypes = {
  categories: _propTypes["default"].arrayOf(_chartDataPropTypes.columnCategoryPropTypes).isRequired,
  allValues: _propTypes["default"].arrayOf(_chartDataPropTypes.groupedColumnPropTypes).isRequired,
  currentValues: _propTypes["default"].arrayOf(_chartDataPropTypes.groupedColumnPropTypes).isRequired,
  currentTab: _propTypes["default"].string.isRequired,
  onChangeCurrentValues: _propTypes["default"].func.isRequired
};
var _default = CategoryCheckboxes;
exports["default"] = _default;